import { dashboardColors, theme } from "../../themes/Theme";
import iconAddImage from "./../../revampComponents/Atom/Icons/iconAddImage.svg";
import ReactHtmlParser from "react-html-parser";

const UploadedImage = props => {
	var styles = {
		uploadButton: {
			backgroundColor: "white",
			padding: "2px",
			boxSizing: "border-box",
			display: "grid",
			position: "relative",
			marginInline: "2px",
			fontSize: "10px",
			lineHeight: "14px",
			textAlign: "center",
			cursor: "pointer",
			width: `${props.size}`,
			height: `${props.height || props.size}`,
			border: `${props.uploadText == "Speaker" ? "0px" : `2px solid ${dashboardColors[theme].primary}`}`,
			borderRadius: `${props.shape == "round" ? "50%" : props.uploadText == "Speaker" ? "7px" : "2px"
				}`
		},
		label: {
			margin: "auto",
			cursor: "pointer"
			// padding: "15px 22px"
		},
		icon: {
			margin: "auto",
			paddingTop: "10px"
		}
	};
	return (
		<>
			<label style={styles.uploadButton} className="uploadButtonClass" htmlFor={props.id}>
				{props.uploadText ? (
					<label style={styles.label} className="plusLabel" htmlFor={props.id}>
						<i className="fas fa-solid fa-camera fa-3x"></i>
						<br />
						<span className="textUpload text-center">{props.uploadText}</span>
					</label>
				) : (
					<label style={styles.label} className="plusLabel" htmlFor={props.id}>
						<img src={iconAddImage} height="36px" width="36px" />
						<br />
						{props.uploadText
							? ReactHtmlParser(props.uploadText)
							: ReactHtmlParser(`Upload <br /> Image`)}
					</label>
				)}
			</label>

			<style jsx>{`
				.plusLabel {
					align-items: center;
					align-content: center;
					display: flex;
					flex-direction: column;
					font-size: 13px;
				}

				.fa-camera {
					color: ${dashboardColors[theme].primary};
				}

				.textUpload {
					font-size: 1rem;
					margin-top: 10px;
				}
			`}</style>
		</>
	);
};

export default UploadedImage;
